<template>
    <div id='subscribe' class='d-flex justify-content-center align-items-center' style='overflow: auto'>
        <div class='container d-flex flex-column align-items-center'>
            <h5>You are all done!</h5>
            <div v-if="!done">
                <p>We will have the results and article published in a month. Give us your email and we will let you know when its out.
                <p>And we promise, you will not receive more than 1 email a month. We hate spam as well! :))</p>
                <div style='width: 100%; text-align: center'>
                    <Textfield placeholder="Enter your email address" @enter="submit" /><br>
                </div>
            </div>
            <div v-else style='text-align: center'>
                <fa-icon icon="smile-beam" />
                <p>Thanks! You will receive an email with the poll results soon! Please wait while you are redirected to the blog ...</p>
            </div>

            <div>
                <a href='javascript: ' @click="showPreviousPage">Go back</a> &middot; <a href='javascript: ' @click="showBlog">Read our experiences</a>
            </div>
        </div>
    </div>
</template>

<script>
import Textfield from  "../widgets/Textfield"
import http from "../../lib/http.ts"

export default {
    name: 'subscribe',
    components: {Textfield},
    props: {
        location: {required: true}
    },

    data() {
        return {email: null, done: false} 
    },

    methods: {
        submit(el){
            if(! el.value) return;
            this.email = el.value;
            http().post("/subscribe", {email: this.email})
            this.done = true;
            this.$ga.event('Subscriptions', 'Subscribe');
            window.setTimeout(this.showBlog, 3000);
        },

        restart() {
            window.location.reload()
        },

        showBlog(){
            this.$emit('show-page', 'blog');
        },

        showPreviousPage() {
            this.$emit('show-page', 'next-location');
        }
    }
}
</script>

<style lang="scss" scoped>
    #subscribe {
        height: 100%;
        .container {max-width: 760px}
        H3 {margin-bottom: 10px}
        P {text-align: center}
        input[type=text] {width: 100%; max-width: 100%; margin-top: 0px; margin-bottom: 20px; text-align: center}
        svg {font-size: 42px; color: green; margin: 20px 0}
    }
</style>